// Where a side panel's top sits (Amir, 26 Oct): lined up with what it opened from (a visit's block), so
// the eye doesn't travel; with nothing to line up with, the top of the region it belongs to (the board's
// time scale). Always inside the viewport: moved up so its foot stays in view, never above the margin it
// keeps from the viewport's top. A panel taller than the viewport sits at the margin (its own height is
// capped there, and it scrolls inside). Where it would sit over what it opened from (a phone, where it
// spans the width), it moves clear of it, so that block can still be tapped (QA-878): under it, a margin
// away, where it fits, else over it; where neither fits, as before.

export interface PanelPlace {
  /** The top of what it opened from, in px from the viewport's top; null when there's none. */
  from: number | null;
  /** The foot of what it opened from, given only when the panel would sit over it. */
  fromFoot?: number | null;
  /** The top of the region it belongs to (the board's time scale); null when there's none. */
  within: number | null;
  /** The panel's own height. */
  height: number;
  /** The viewport's height. */
  viewport: number;
  /** The room it keeps from the viewport's top and foot (--panel-top). */
  margin: number;
}

/** The panel's top, in px from the viewport's top. */
export function panelTop({ from, fromFoot, within, height, viewport, margin }: PanelPlace): number {
  const lowest = viewport - margin - height;
  if (from !== null && fromFoot != null) {
    const under = fromFoot + margin;
    if (under <= lowest) return Math.round(under);
    const over = from - margin - height;
    if (over >= margin) return Math.round(over);
  }
  const want = from ?? within ?? margin;
  return Math.round(Math.max(margin, Math.min(want, lowest)));
}
